
/* injects from baggage-loader */

'use strict';

import './summaryDialog.scss';
import summaryService from './summary.service';
import summaryConstant from "./summary.constant";

/**
 * Summary module definition.
 */
const summaryModule = angular.module('summary.module', []);

summaryModule.service('summaryService', summaryService);
summaryModule.constant('summaryConstant', summaryConstant);

export default summaryModule;



// WEBPACK FOOTER //
// ./src/app/auth/components/summary/summary.module.js